import { FontAwesome } from '@expo/vector-icons';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';

const SocialButton = ({
  title,
  icon,
  onPress,
  disabled,
  style,
  textStyle,
  iconColor,
  imageIcon,
}) => {
  return (
    <TouchableOpacity
      style={[styles.button, style, disabled && { opacity: 0.5 }]}
      onPress={onPress}
      disabled={disabled}
    >
      <View style={styles.content}>
        {imageIcon ? (
          <Image source={imageIcon} style={[styles.icon, { width: 40, height: 40 }]} />
        ) : (
          icon && (
            <FontAwesome name={icon} size={20} color={iconColor || 'white'} style={styles.icon} />
          )
        )}
        <Text style={[styles.text, textStyle]}>{title}</Text>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    backgroundColor: '#1D1E22',
    borderWidth: 1,
    borderColor: '#373737',
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    marginRight: 10,
  },
  text: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 14,
    color: '#FFFFFF',
  },
});

export default SocialButton;
